export enum SimulateChartTypes {
    FETCH_INIT_RUN_FIXED_SCHEDULE = '@SimulateChart/FETCH_INIT_RUN_FIXED_SCHEDULE',
    FETCH_FIXED_SCHEDULE_SUMMARY = '@SimulateChart/FETCH_FIXED_SCHEDULE_SUMMARY',
    FETCH_HYBRID_REVENUES = '@SimulateChart/FETCH_HYBRID_REVENUES',
}
